module.exports = __webpack_public_path__ + "img/b1-3.a66c37d.png";